import React from 'react'
import { AsyncSelectField, AsyncSelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { ExtendableStyles } from 'utils-next/types'

import { getApiUserHandlers, User } from '../../../../../../../../../entities-next/user'

export type OpsLeadSelectProps = ExtendableStyles &
  Omit<AsyncSelectFieldProps, 'promiseFn' | 'getOptionLabel' | 'getOptionSelected' | 'getCreatedOption' | 'cacheKey'>

const notAssigned = 'Not assigned'
function getOpsLeadLabel(option: User | null) {
  let opsLead = ''

  if (option) {
    if (option.firstName) {
      opsLead = option.firstName
    }
    if (option.lastName) {
      opsLead = opsLead + ' ' + option.lastName
    }
    if (option.email) {
      opsLead = opsLead + ' ' + `(${option.email})`
    }
    return opsLead
  }
  return notAssigned
}

function getOpsLeadSelected(option: User, value: number) {
  return option.id === value
}

function cacheKeyFn() {
  return 'assignedOpsLeadId'
}

async function getOpsLead() {
  const { apiGetOpsLeadList } = getApiUserHandlers()
  const users = await apiGetOpsLeadList()
  return users.results
}
export function OpsLeadSelect(selectProps: OpsLeadSelectProps) {
  return (
    <AsyncSelectField
      promiseFn={getOpsLead}
      getOptionLabel={getOpsLeadLabel}
      getOptionSelected={getOpsLeadSelected}
      {...selectProps}
      cacheKeyFn={cacheKeyFn}
    />
  )
}
